// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { ApplicationFrameContextProvider } from "./ApplicationFrameContextProvider";
import { ApplicationFrameHelp } from "./ApplicationFrameHelp";
import { ApplicationFrameMenu } from "./ApplicationFrameMenu";
import { ApplicationFrameNotification } from "./ApplicationFrameNotification";
import { ApplicationFooter } from "../ApplicationFooter";
import { ApplicationHeader } from "../ApplicationHeader";
import { ApplicationLauncher } from "../ApplicationLauncher";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ApplicationFrame = props => {
  const {
    content,
    header,
    footer
  } = props;
  return React.useMemo(() => /*#__PURE__*/_jsx(ApplicationFrameContextProvider, {
    children: /*#__PURE__*/_jsx(ApplicationLauncher, {
      children: /*#__PURE__*/_jsx(ApplicationFrameNotification, {
        children: /*#__PURE__*/_jsx(ApplicationFrameHelp, {
          children: /*#__PURE__*/_jsx(ApplicationFrameMenu, {
            children: /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%"
              },
              children: [/*#__PURE__*/_jsx(ApplicationHeader, {
                children: header
              }), content, /*#__PURE__*/_jsx(ApplicationFooter, {
                children: footer
              })]
            })
          })
        })
      })
    })
  }), [content, header, footer]);
};